import api from '../../utils/api.js';

export const MESSAGE_ADDED = 'MESSAGE_ADDED';
export const MESSAGE_FILES_UPLOADED = 'MESSAGE_FILES_UPLOADED';
export const MESSAGE_FILES_UPLOADING = 'MESSAGE_FILES_UPLOADING';
export const MESSAGE_PREPEND = 'MESSAGE_PREPEND';
export const THREAD_OPENED = 'THREAD_OPENED';
export const MESSAGE_RECEIVED = 'MESSAGE_RECEIVED';
export const USERS_RETRIEVED = 'USERS_RETRIEVED';
export const THREAD_CREATED = 'THREAD_CREATED';
export const INITIAL_THREADS = 'INITIAL_THREADS';
export const IS_TYPING = 'IS_TYPING';
export const MESSAGE_SEEN = 'MESSAGE_SEEN';
export const MESSAGE_FILE_DELETED = 'MESSAGE_FILE_DELETED';
export const CLEAR_MESSAGE_FILES = 'CLEAR_MESSAGE_FILES';
export const STATUS_CHANGE = 'STATUS_CHANGE';
export const LOADED_THREAD_FILES = 'LOADED_THREAD_FILES';
export const THREAD_UPDATED = 'THREAD_UPDATED';
export const TICKET_SOLVED = 'TICKET_SOLVED';
export const TICKET_CLOSED = 'TICKET_CLOSED';
export const THREAD_FIELD_UPDATED = 'THREAD_FIELD_UPDATED';
export const MESSAGE_UPDATED = 'MESSAGE_UPDATED';
export const REPORTED_COMMENTS_GOT = 'REPORTED_COMMENTS_GOT';
export const REPORT_RESOLVED = 'REPORT_RESOLVED';
export const FILE_DELETED = 'FILE_DELETED';
export const LOADED_ATTACHMENTS = 'LOADED_ATTACHMENTS';
export const LOADED_INSTRUCTORS = 'LOADED_INSTRUCTORS';
export const ANNOUNCEMENT_ADDED = 'ANNOUNCEMENT_ADDED';
export const LOADED_ANNOUNCEMENTS = 'LOADED_ANNOUNCEMENTS';
export const ANNOUNCEMENT_DELETED = 'ANNOUNCEMENT_DELETED';
export const SETTINGS_RETRIEVED = 'SETTINGS_RETRIEVED';
export const SETTINGS_UPDATED = 'SETTINGS_UPDATED';
export const INCREASE_UNREAD = 'INCREASE_UNREAD';
export const RESET_UNREAD = 'RESET_UNREAD';
export const SIDEBAR_TAB_SET = 'SIDEBAR_TAB_SET';

function messageAdded(message){
    return {
        type: MESSAGE_ADDED,
        payload: message
    }
}
export function addMessage(message){
    return dispatch => {
        dispatch(messageAdded(message));
    }
}

export function prependMessages(messages){
    if(messages.length > 0){
        return {
            type: MESSAGE_PREPEND,
            payload: messages
        }
    }
}



function usersRetrieved(users){
    return {
        type: USERS_RETRIEVED,
        payload: users
    }
}

export function getUsers(profileId, token){
    return dispatch => {
        // WE DO NOT NEED TO GET ALL USERS!!!

        /*


        api.getProfiles(token, res => {
            if(res.status === 200){
                dispatch(usersRetrieved(res.data));
            }
        })

         */
    }
}

function addedThread(thread){
    return {
        type: THREAD_CREATED,
        payload: thread
    }
}

export function threadCreated(thread, redirect){
    return dispatch => {
        dispatch(addedThread(thread))
        if(redirect){
            if(window.location.href.indexOf("chat") > -1){
                window.location.href = "/chat/" + thread.id;
            }
        }
    }
}

export function setInitialThreads(threads, token){
    return dispatch => {
        threads.map((t, ti) => {
            api.getThreadMessageCount(t.id, token, res => {
                t.responses = res.data.count;

                if(ti === threads.length - 1){
                    dispatch({
                        type: INITIAL_THREADS,
                        payload: threads
                    })
                }
            })
        })

        
    }
    
}

export function getChatLecures(subjectId, token){
    return dispatch => {
        api.getChatLectures(subjectId, token, res => {
            dispatch({
                type: 'GOT_CHAT_LECTURES',
                payload: res.data
            })
        })
    }
}

export function getThreads(profileId, token){
    return dispatch => {
        api.getChatThreads(profileId, token, res => {
            dispatch(setInitialThreads(res.data));
        })
    }
}

function typingSet(typing){
    return {
        type: IS_TYPING,
        payload: typing
    }
}

export function setIsTyping(typing){
    return dispatch => {
        dispatch(typingSet(typing));
    }
}

function messageSeen(seen){
    return {
        type: MESSAGE_SEEN,
        payload: seen
    }
}

export function setSeen(seen){
    return dispatch => {
        dispatch(messageSeen(seen));
    }
}

function messageFilesUploaded(files){
    return {
        type: MESSAGE_FILES_UPLOADED,
        payload: files
    }
}

function messageFilesUploading(files){
    let f = [];
    
    for(let i = 0; i < files.length; i++){
        f.push(files[i]);
    }
    return {
        type: MESSAGE_FILES_UPLOADING,
        payload: f
    }
}

export function uploadMessageFiles(files, profileId, token){
    return dispatch => {
        dispatch(messageFilesUploading(files));
        api.uploadMessageFiles(files, profileId, token, res => {
            dispatch(messageFilesUploaded(res.data));
        })
    }
}


function messageFileDeleted(file){
    return {
        type: MESSAGE_FILE_DELETED,
        payload: file
    }
}

export function cancelMessageFile(file, profileId, token){
    return dispatch => {
        api.deleteMessageFile(file, profileId, token, res => {
            dispatch(messageFileDeleted(file));
        })
    }
}

export function clearMessageFiles(){
    return {
        type: CLEAR_MESSAGE_FILES,
        payload: {}
    }
}

export function handleStatusChange(data, profileId){
    return {
        type: STATUS_CHANGE,
        payload: {data: data, profileId, profileId}
    }
}


export function loadedThreadFiles(data){
    return {
        type: LOADED_THREAD_FILES,
        payload: data
    }
}

export function threadUpdated(thread, profileId){
    thread.myprofileId = profileId;
    return {
        type: THREAD_UPDATED,
        payload: thread
    }
}

export function ticketSolved(thread, profileId){
    return {
        type: TICKET_SOLVED,
        payload: thread
    }
}

export function ticketClosed(thread, profileId){
    return {
        type: TICKET_CLOSED,
        payload: thread
    }
}

export function threadFieldUpdated(thread){
    return {
        type: THREAD_FIELD_UPDATED,
        payload: thread
    }
}

export function messageUpdated(message){
    return {
        type: MESSAGE_UPDATED,
        payload: message
    }
}

export function loadedReportedComments(data){
    return {
        type: REPORTED_COMMENTS_GOT,
        payload: data
    }
}

export function resolveReport(data){
    return {
        type: REPORT_RESOLVED,
        payload: data
    }
}

export function deleteAttachment(data){
    return {
        type: FILE_DELETED,
        payload: data
    }
}

export function loadedAttachments(data){
    return {
        type: LOADED_ATTACHMENTS,
        payload: data
    }
}

export function loadedInstructors(data){
    return {
        type: LOADED_INSTRUCTORS,
        payload: data
    }
}

export function announcementAdded(data){
    return {
        type: ANNOUNCEMENT_ADDED,
        payload: data
    }
}

export function loadedAnnouncements(data){
    return {
        type: LOADED_ANNOUNCEMENTS,
        payload: data
    }
}

export function announcementDeleted(data){
    return {
        type: ANNOUNCEMENT_DELETED,
        payload: data
    }
}

function settingsRetrieved(data){
    return {
        type: SETTINGS_RETRIEVED,
        payload: data
    }
}

export function getSettings(){
    return dispatch => {
        api.getSettings(res => {
            dispatch(settingsRetrieved(res));
        })
    }
}

export function settingsUpdated(data){
    return {
        type: SETTINGS_UPDATED,
        payload: data
    }
}

export function addToUnreadCount(threadId){
    return {
        type: INCREASE_UNREAD,
        payload: threadId
    }
}

export function resetUnread(threadId){
    return {
        type: RESET_UNREAD,
        payload: threadId
    }
}

export function setSidebarTab(tab){
    return {
        type: SIDEBAR_TAB_SET,
        payload: tab
    }
}

export function messengerSearch(term, token) {
    return dispatch => {
        api.messengerSearch(term, token, res => {
            dispatch({
                type: 'MESSENGER_SEARCHED',
                payload: res.data.results
            })
        })
    }
}


// WEBPACK FOOTER //
// ./src/store/actions/chatActions.js